import React from 'react';
import PropTypes from 'prop-types';
import CaracteristicaLenteSelectCard from './CaracteristicaLenteSelectCard';
import { Box, Flex } from '../../../shared/components';
import CaracteristicaLenteClickableCard from './CaracteristicaLenteClickableCard';

export default function ConfiguracionLentePanel({
  multiselect, configuracion, caracteristicasSeleccionadas, onSelectCaracteristica, opciones,
}) {
  const {
    id, numeroDeFotos,
  } = configuracion;


  function onSelect(configuracion, caracteristica) {
    onSelectCaracteristica(configuracion, caracteristica);
  }

  const boxOpciones = opciones && opciones.map((caracteristica, index) => {
    const { valor: valorCaracteristica, id: idCaracteristica } = caracteristica;
    let valorSeleccionado;
    let idSeleccionada;
    const margin = index !== 0 ? '24' : '0';
    const { foto, opciones: opcionesCaracteristica } = caracteristica;
    let selector = null;
    const esTipoSelect = opcionesCaracteristica !== undefined;
    let backgroundImage;

    if (foto) {
      backgroundImage = `${process.env.PUBLIC_URL}/${foto}`;
    } else {
      const pathIndex = ((index + 1) > numeroDeFotos) ? (numeroDeFotos - 1) : index;
      backgroundImage = `${process.env.PUBLIC_URL}/img/pel/${id}/${pathIndex}.svg`;
    }

    if (caracteristicasSeleccionadas) {
      const { multiselect } = configuracion;
      if(multiselect) {
        const caracteristicaSeleccionada = caracteristicasSeleccionadas[valorCaracteristica];
        if (caracteristicaSeleccionada) {
          valorSeleccionado = caracteristicaSeleccionada.valor;
          idSeleccionada = caracteristicaSeleccionada.id;
        }
      } else {
        const { valor: valorCaracteristicaSeleccionada, id: idCaracteristicaSeleccionada } = caracteristicasSeleccionadas;
        valorSeleccionado = valorCaracteristicaSeleccionada;
        idSeleccionada = idCaracteristicaSeleccionada;
      }
    }
    if (esTipoSelect) {
      const key = `${id}_select_${index}_${idCaracteristica}`;
      selector = (
        <CaracteristicaLenteSelectCard
          key={key}
          valorSeleccionado={valorSeleccionado}
          caracteristica={caracteristica}
          backgroundImage={backgroundImage}
          onSelect={(caracteristica) => {
            onSelect(configuracion, caracteristica);
          }}
        />
      );
    } else {
      const key = `${id}_clickable_${index}_${idCaracteristica}`;
      selector = (
        <CaracteristicaLenteClickableCard
          key={key}
          valorSeleccionado={valorSeleccionado}
          idSeleccionada={idSeleccionada}
          caracteristica={caracteristica}
          backgroundImage={backgroundImage}
          onSelect={(caracteristica) => {
            onSelect(configuracion, caracteristica);
          }}
        />
      );
    }
    const panelKey = `${id}_panel_${index}_${idCaracteristica}`;
    return (
      <Box flex={1} ml={margin} key={panelKey}>
        {selector}
      </Box>
    );
  });

  return (
    <Flex>
      {boxOpciones}
    </Flex>
  );
}

ConfiguracionLentePanel.propTypes = {
  caracteristicasSeleccionadas: PropTypes.any,
  configuracion: PropTypes.shape({
    id: PropTypes.string,
    nombre: PropTypes.string,
    valor: PropTypes.number,
  }).isRequired,
  onSelectCaracteristica: PropTypes.func.isRequired,
  multiselect: PropTypes.bool,
};
ConfiguracionLentePanel.defaultProps = {
  caracteristicaSeleccionada: {
    nombre: '', valor: null,
  },
  multiselect: false,
};
